import { render } from "./RuMainMenu.vue?vue&type=template&id=f51be9a2"
import script from "./RuMainMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./RuMainMenu.vue?vue&type=script&setup=true&lang=js"

import "./RuMainMenu.vue?vue&type=style&index=0&id=f51be9a2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/RuMainMenu/RuMainMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f51be9a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f51be9a2', __exports__)) {
    api.reload('f51be9a2', __exports__)
  }
  
  module.hot.accept("./RuMainMenu.vue?vue&type=template&id=f51be9a2", () => {
    api.rerender('f51be9a2', render)
  })

}


export default __exports__